import React from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { Icon } from '../icon/icon';
import styles from './form-inline-notification.module.scss';

type InlineNotificationType = 'error' | 'warning';

export type InlineNotification = {
  type: InlineNotificationType;
  message: string;
};

type Props = {
  type: InlineNotificationType;
  children: string;
};

export const FormInlineNotification: React.FC<Props> = ({ type, children }) => {
  const isError = type === 'error';
  return (
    <div className={classNames(styles.root, { [styles.isError]: isError })}>
      <Icon className={styles.icon} size="16" variant={isError ? 'circle-cross' : 'triangle-exclamation-mark'} />
      <Typography color={isError ? 'white' : 'black'} variant="smalltext">
        {children}
      </Typography>
    </div>
  );
};
